
import React from "react";
import CarouselItem from "./CaroItem";
import './carousel.css';
import { useState, useEffect } from "react";
export default function AutoplayCarousel({cardDetails, height}) {
    const [jsx, setjsx] = useState([])
    useEffect(() => {
        const details = [...Object.values(cardDetails)]
        const temp = []
        for(let i = 0; i < details.length; i+=2){
            const group =  (<div className="carousel-item-group">
                <CarouselItem obj={details[i]}/>
                <CarouselItem obj={details[i+1]}/>
            </div>)
            temp.push(group)
        }
        setjsx(temp)
    },[])
  return (
        <div className="carousel-container select-none">
            <div className="carousel-track">
                {jsx}
                {jsx}
                {jsx}
            </div>
        </div>
  );
}